import moduleConfig from './module-config';
import netsLegacyReset from './nets-legacy-reset';

export default angular
  .module('app.legacyReset', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsLegacyReset', netsLegacyReset);
